import { render, staticRenderFns } from "./nurseDetail.vue?vue&type=template&id=edd68c3a&scoped=true&"
import script from "./nurseDetail.vue?vue&type=script&lang=js&"
export * from "./nurseDetail.vue?vue&type=script&lang=js&"
import style0 from "./nurseDetail.vue?vue&type=style&index=0&id=edd68c3a&prod&lang=scss&"
import style1 from "./nurseDetail.vue?vue&type=style&index=1&id=edd68c3a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd68c3a",
  null
  
)

export default component.exports